<template>
  <div class="left_nav">

    <el-menu default-active="1-4-1" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
      @click="menuClick" :collapse="isCollapse" :router="false">
      <div class="menu">
        <i class="el-icon-menu" @click="isCollapse=!isCollapse" style="font-size:20px"></i>
      </div>

      <el-submenu v-for="(item,firstIndex) in getNavList.hasChild" :key="item.menu_id" :index="firstIndex+''">
        <template slot="title">
          <i class="fa fa-bars"></i>
          <span slot="title">{{item.menu_name}}</span>
        </template>
        <el-menu-item v-for="(secondMenu, index) in item.children_list" :key="index" @click="addActiveTabs(secondMenu)"
          :index="secondMenu.route_url" :class="secondMenu.route_url===activeTab?'active':''">
          <i :class="secondMenu.menu_css===''?'fa-bars':secondMenu.menu_css" class="fa"></i>
          <span slot="title">{{secondMenu.menu_name}}</span>
        </el-menu-item>
      </el-submenu>
      <el-menu-item v-for="(item) in getNavList.noChild" :key="item.menu_id" @click="addActiveTabs(item)"
        :index="item.route_url" :class="item.route_url===activeTab?'active':''">
        <i :class="item.menu_css===''?'fa-bars':item.menu_css" class="fa"></i>
        <span slot="title">{{item.menu_name}}</span>
      </el-menu-item>
      <!-- <div role="menuitem"
           class="el-submenu"
           v-for="(item,firstIndex) in getNavList"
           :key="item.menu_id">

      </div> -->

    </el-menu>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        isCollapse: false,
        user: {}
      };
    },
    computed: {
      // getNavList () {
      //   let store = this.$store.state.sideNav
      //   let local = JSON.parse(window.localStorage.getItem('sideNav') || [])
      //   let sideNav = store.length > 0 ? store : local
      //   console.log(sideNav, 'side')
      //   return sideNav
      // },

      getNavList() {
        let store = this.$store.state.sideNav
        let local = JSON.parse(window.localStorage.getItem('sideNav')) || []
        let sideNav = store.length > 0 ? store : local
        let navListObj = {
          hasChild: [],
          noChild: []
        }
        if (sideNav.length > 0) {
          sideNav.map((item) => {
            if (item.children_list) {
              navListObj.hasChild.push(item)
            } else {
              navListObj.noChild.push(item)
            }
          })
        }
        // console.log(sideNav, 'side')
        return navListObj
      },
      activeTab() {
        let store = this.$store.state.activeTab
        let local = window.localStorage.getItem('activeTab')
        let name = store === '' ? store : local
        return name
      }
    },
    components: {

    },
    created() {
      let userInfoLocal = window.localStorage.getItem('userInfo') || '{}'
      this.user = JSON.parse(userInfoLocal)
    },
    mounted() { },
    methods: {
      menuClick(data) {

      },
      handleOpen(key, keyPath) {

      },
      handleClose(key, keyPath) {

      },
      // 点击菜单时将路由加载到激活状态的路由列表中
      addActiveTabs(nav) {
        console.log(nav, 'click')
        let menuType = nav.menu_type
        if (menuType === '1') {
          this.$router.push({
            path: "/" + nav.route_url
          });
        } else if (menuType === '2') {
          let link = nav.route_url
          // 解析url，获得目标网址
          let host = link.split('?')[0]
          // 获取携带的参数
          let params = link.split('?')[1].split('&')
          // 处理后的数组
          let res = []
          params.map((item) => {
            // 遍历参数列表，解析出key和要携带的值
            let key = item.split('=')[0]
            let value = item.split('=')[1]
            // 因为分割出的值是类似{user.short_key}格式的，需要把前后的大括号去掉
            let valueLen = value.length
            // 最后得到user.short_key这样的格式，表示全局有一个user对象，取其中short_key的值
            value = value.substr(2, valueLen - 3)
            let targetObj = value.split('.')[0]
            let targetObjKey = value.split('.')[1]
            let str = key + '=' + this[targetObj][targetObjKey]
            res.push(str)
          })
          let newLink = host + '?' + res.join('&')

          window.open(newLink);
        } else {

        }
        this.$store.dispatch('setActiveTabs', nav)
      }
    }
  };
</script>

<style scoped lang="scss">
  .left_nav {
    width: auto;
    height: 100%;
    border-right: solid 1px #e6e6e6;

    .el-menu {
      .el-menu-item {
        &.is-active {
          color: #303133;
        }

        &.active {
          color: #409eff;
        }
      }
    }
  }

  /deep/.el-menu {
    border: none;
  }

  .menu {
    width: 100%;
    height: 40px;
    text-align: center;
    line-height: 40px;
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }
</style>


// WEBPACK FOOTER //
// src/components/nav/leftNav.vue